import { compose, branch, renderNothing } from 'recompose'
import withTags from 'components/shared/withTags'
import TagList from './component'

export default compose(
  withTags,
  branch(({ isTagsByIdLoaded }) => !isTagsByIdLoaded, renderNothing),
)(TagList)



// WEBPACK FOOTER //
// ./src/scripts/components/TagList/index.js